<div  *ngIf="type==1" class=" border backg linkPadding"  >
    <div class="padding-10 backg" fxLayout="row">
      <b class="f20">Product Description
      </b>
    </div>
    <mat-divider></mat-divider>
    <div>
      <div class="padding-10 backg">
        <div >

          <div  fxLayout="row" class="padding-10">
            
            <div fxLayout="row" fxFlex>
              <p [innerHTML]="spec" > </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div *ngIf="type==2">
    <div class="full-desc lh">
      <div fxLayout="row" fxFlex>
        <p [innerHTML]="spec"> </p>
      </div>
    </div>
  </div>